var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switchIdentity',{attrs:{"list":_vm.memberProviders,"selected":_vm.selectedProvider,"title":"請選擇要管理的供應商","register_btn":"申請新供應商"},on:{"switchIdentity":_vm.clickSwitchIdentity,"register":_vm.clickRegisterProvider}})}
var staticRenderFns = []

export { render, staticRenderFns }